<template>
  <div v-if="data">
    <div class="title base">
      <p id="name">{{ $t("商品") }}</p>
      <p id="time">{{ $t("下单时间") }}</p>
      <p id="to">{{ $t("收货人") }}</p>
      <p id="count">{{ $t("合计") }}</p>
      <p id="stat">{{ $t("状态") }}</p>
      <p id="operation">{{ $t("操作") }}</p>
    </div>
    <div v-if="dataLength">
      <div v-for="tr in data.items" :key="tr.id" class="border mb-4">
        <div class="col-span-6 border-b p-4 flex flex-nowrap">
          <span class="">{{ $t("订单号") }}：{{ tr.ordernum }}</span>
          <!-- <span class="ml-auto"
            ><FlightBoard class="inline-block" :item="tr.flight"></FlightBoard
          ></span> -->
        </div>
        <div class="base pstyle">
          <div class="h-full border-r w-full divide-y-1 justify-self-center">
            <div v-for="item in tr.items" :key="item.id" class="flex p-2">
              <img :src="$firstImage(item.images, 'small')" alt="" class="img w-32 h-32 p-2" :onerror="defaultUrl" />
              <div class="flex justify-between w-70 pt-2">
                <p class="font-semibold">{{ item.name }}</p>
                <p class="text-right pr-5">
                  <span class="block font-semibold">{{ $p(item.price) }}</span>
                  <span class="block text-gray-400">×{{ item.quantity }}</span>
                </p>
              </div>
            </div>
          </div>
          <p class="">{{ tr.created.date }}</p>
          <p>{{ tr.receiver }}</p>
          <p class="text-red-500">{{ $p(tr.finalprice) }}</p>
          <p class="text-green-500 flex-wrap">
            <span>
              <span class="block">{{ orderStatus[tr.status] }}</span>
              <span class="block">
                <el-link type="info" :underline="false" class="block">
                  <router-link :to="{ name: 'OrderDetail', params: { id: tr.id } }">{{ $t("订单详情") }}</router-link>
                </el-link>
              </span>
            </span>
          </p>
          <p>
            <!-- <span v-if="tr.status === -1">
              <el-link type="danger" :underline="false" class="block" @click="removeOrder(tr.id)">
                {{ $t(" 删除") }}
              </el-link>
            </span> -->
            <span v-if="tr.status === 0">
              <el-button class="take" @click="getTypes(tr.supplier_id, tr)" type="warning" size="small" round>
                {{ $t("去付款") }}
              </el-button>
              <el-link type="danger" :underline="false" class="block" @click="cancelOrder(tr.id)">
                {{ $t("取消订单") }}
              </el-link>
            </span>
            <span v-else-if="tr.status == 10">
              <el-button class="take" type="warning" size="small" round @click="remind(tr.id)">{{ $t('提醒发货')
              }}</el-button>
            </span>
            <span v-else-if="tr.status === 100">
              <el-button class="take" @click="finishOrder(tr.id)" round type="warning" size="small">
                {{ $t("确认收货") }}
              </el-button>
            </span>
            <span v-else-if="tr.status === 10">
              <!-- <el-button
                type="warning"
                round
                size="small"
                class="take"
                disabled
              >
                {{ $t("确认收货 ") }}
              </el-button> -->
              <!-- <span @click="next(tr)">next</span> -->
            </span>
            <span v-else-if="tr.status === 1000">
              <el-button type="primary" round size="small" class="comment" @click="comment(tr.id)" v-if="!tr.commenttime">
                {{ $t("评价") }}
              </el-button>
              <el-link type="info" :underline="false" class="block" v-else>
                {{ $t("已评价") }}
              </el-link>
              <!-- <el-link type="danger" :underline="false" class="block" @click="removeOrder(tr.id)">
                {{ $t("删除") }}
              </el-link> -->
            </span>
          </p>
        </div>
      </div>
      <div id="foot" class="mt-6" v-if="data.total">
        <el-pagination background layout="prev, pager, next" :total="Number(dataLength)" :page-size="5"
          @current-change="handleCurrentChange" :current-page.sync="currentPage"
          :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
    <div v-else class="mt-60">
      <img :src="require(`@/assets/image/暂无订单.png`)" class="mx-auto" />
    </div>
    <pay-info :show="showPayInfo" :sid="curId" @close="showPayInfo = false"></pay-info>
    <el-dialog :title="$t('选择付款方式')" :visible.sync="showPayType">
      <div class="space-x-20 flex-center">
        <div v-for="type in types" @click="goPay(type.key)" :key="type.key">
          <img :src="$smallImage(type.img)" class="w-16 h-16">
          <el-link>{{ type.text }}</el-link>
        </div>
      </div>
    </el-dialog>
    <ReadyPay ref="readypay"></ReadyPay>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";
import { ref, watchEffect, onUpdated, reactive } from "@vue/composition-api";
// import FlightBoard from "./flightBoard.vue";
import payInfo from "../../base/payInfo.vue";
import ReadyPay from "/src/components/base/ir-readypay.vue";

export default defineComponent({
  components: { payInfo, ReadyPay },
  props: { data: Object, page: Number },
  setup(props, ctx) {
    const currentPage = ref();
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    watchEffect(() => {
      currentPage.value = props.page;
    });

    const dataLength = ref();
    onUpdated(() => {
      dataLength.value = props.data?.items?.length ? props.data.total : 0;
    });
    const handleCurrentChange = () => {
      document.documentElement.scrollTop = 0;
      ctx.emit("updataPage", currentPage.value);
    };
    //删除订单
    const removeOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定要删除订单?"));
      if (res) {
        ctx.emit("remove", id, "delete");
      }
    };
    //取消订单
    const cancelOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定要取消订单?"));
      if (res) {
        ctx.emit("cancel", id, "cancel");
      }
    };
    const next = async (e) => {
      const res = await ctx.root.$callapi("user/doForOrderAction", {
        ids: [e.id],
        action: "sent",
      });
    };
    //去付款
    const curId = ref()
    const curOrder = ref()
    const showPayInfo = ref(false)
    const readypay = ref(null);
    const showPayType = ref(false)

    const getTypes = async (id, order) => {
      showPayType.value = true
      curId.value = id
      curOrder.value = order
    };
    const goPay = async (key) => {
      if (key == 'online') {
        ctx.root.$refs.readypay = readypay.value;
        let r = await ctx.root.$startPay({
          payfor: "newpay", // 收银台订单
          money: curOrder.value.finalprice, // 金额
          title: ctx.root.$t("支付订单{num}").replace("{num}", curOrder.value.ordernum),
          data: {
            oid: curOrder.value.id,
            now_platform: "webpc",
            origin_url: "/mine/order" // 从哪个页面发起付款的
          },
        });
      } else if(key == 'offline'){
        showPayInfo.value = true
      }

    }
    //确认收货
    const finishOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定已收到货?"));
      if (res) {
        ctx.emit("finish", id, "finish");
      }
    };
    //去评价
    const comment = (id) => {
      ctx.root.$router.push({
        name: "evaluation",
        params: { id },
      });
    };

    // 提醒发货
    const remind = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("点击确认将向商家发送发货提醒?"));
      if (res) {
        ctx.emit('remind', id, 'remind')
      }

    }
    const orderStatus = reactive({
      '-1': ctx.root.$t('已取消'),
      '0': ctx.root.$t('待付款'),
      '10': ctx.root.$t('待发货'),
      '100': ctx.root.$t('待收货'),
      '1000': ctx.root.$t('已完成')
    })
    const types = [
      {
        key: 'online',
        img: 'https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230424/Ft1w8EX_8QbnQ_cT5xhpXBm69jWS.png',
        text: ctx.root.$t('在线支付')
      },
      {
        key: 'offline',
        img: 'https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230424/FhIbNw2RXvuidXhueMyEYmPIjUFT.png',
        text: ctx.root.$t('记账支付')
      }
    ]



    return {
      handleCurrentChange,
      currentPage,
      dataLength,
      removeOrder,
      cancelOrder,
      next,
      finishOrder,
      comment,
      defaultUrl,
      goPay,
      showPayInfo,
      curId,
      remind,
      orderStatus,
      readypay,
      showPayType,
      types,
      getTypes
    };
  },
});
</script>

<style scoped lang="scss">.base {
  display: grid;
  grid-template-columns: 3fr repeat(5, 1fr);
}
.pstyle>p {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-right-width: 1px;
  height: 100%;
}
.pstyle>p:last-child {
  border-right-width: 0px;
}
.title {
  border-width: 1px;
  margin-bottom: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background-color: #f4f4f5;
}
.take {
  min-width: 5.6rem;
  font-size: 0.8rem;
  background: linear-gradient(-97.27deg, #ff4a4a 0%, #ff8a00 100%);
}
.take:hover {
  background: #ff8a00;
}
.comment {
  min-width: 5.6rem;
  font-size: 00.8rem;
  background: linear-gradient(-97.27deg, #6ed490 0%, #34b66b 100%);
  border: 0;
}
.comment:hover {
  background: #6ed490;
}</style>
